import request from '../../src/state/modules/axios'

export function getRegions(data){
    return request({
        url: '/api/erp-regions',
        method: 'get',
        params: data
    })
}

export function getRayons(region_id){
    return request({
        url:'/api/erp-rayons/'+ region_id,
        method:'get',
    })
}
